var map = {
	"./247-ai.webp": "./src/assets/images/logo-images/output_webp/247-ai.webp",
	"./deloitte.webp": "./src/assets/images/logo-images/output_webp/deloitte.webp",
	"./idea-infinity.webp": "./src/assets/images/logo-images/output_webp/idea-infinity.webp",
	"./mphasis.webp": "./src/assets/images/logo-images/output_webp/mphasis.webp",
	"./nokia.webp": "./src/assets/images/logo-images/output_webp/nokia.webp",
	"./sagility.webp": "./src/assets/images/logo-images/output_webp/sagility.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/logo-images/output_webp sync \\.webp$";